/**
 * @fileoverview GET handler for the "/engagement/email-message/dnd-editor/access-token" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementEmailMessageDndEditorAccessToken } from "./constants";
import type { EngagementEmailMessageDndEditorAccessTokenResult } from "./types";

export const getEngagementEmailMessageDndEditorAccessToken = reactQueryFetcherAdapter(
  engagementEmailMessageDndEditorAccessToken,
  (signal: AbortSignal): Promise<EngagementEmailMessageDndEditorAccessTokenResult> => {
    return fetch(
      "/engagement/email-message/dnd-editor/access-token",
      "GET",
      {},
      { signal },
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
